import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8e9a02e4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "default-layout"
};
const _hoisted_2 = {
  class: "default-layout-header"
};
const _hoisted_3 = {
  class: "my-blog"
};
const _hoisted_4 = {
  class: "my-blog-btns"
};
const _hoisted_5 = {
  class: "default-layout-main"
};
const _hoisted_6 = {
  class: "default-layout-main-part"
};
import { computed } from 'vue';
import { useRouter } from 'vue-router';
// router
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    // 标题类名计算
    const myBlogClasslist = computed(() => {
      const {
        name: currentName
      } = router.currentRoute.value;
      const classList = ['my-blog-title'];
      // 读文章时标题变色
      if (currentName === 'article') {
        if (CSS.supports && CSS.supports('background-clip', 'text')) {
          // 支持`background-clip`时
          classList.push('reading-article');
        } else {
          // 不支持`background-clip`时
          classList.push('reading-article-backup');
        }
      }
      return classList;
    });
    // 是否显示"关于我"
    const isAboutMeShow = computed(() => {
      const {
        name: currentName
      } = router.currentRoute.value;
      return currentName !== 'about';
    });
    // 是否显示"回首页"
    const isGoBackShow = computed(() => {
      const {
        name: currentName
      } = router.currentRoute.value;
      return currentName !== 'home';
    });
    // 跳转 "关于我"
    function toAboutMe(e) {
      e.preventDefault();
      router.push({
        name: 'about'
      });
    }
    // 跳转首页
    function toHome(e) {
      e.preventDefault();
      router.push({
        name: 'home'
      });
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
        type: "button",
        class: _normalizeClass(myBlogClasslist.value),
        onClick: toHome
      }, " 呦，来啦～ ", 2), _createElementVNode("div", _hoisted_4, [isAboutMeShow.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "my-blog-btns-btn to-about-me",
        onClick: toAboutMe
      }, " 关于我 ")) : _createCommentVNode("", true), isGoBackShow.value ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "my-blog-btns-btn to-home",
        onClick: toHome
      }, " 回首页 ")) : _createCommentVNode("", true)])])]), _createElementVNode("main", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_router_view)])])]);
    };
  }
});